import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "input", "status"]
  static values = {
    projectId: Number,
    canPost: Boolean,
    basePath: { type: String, default: "/ui-planning" }
  }

  connect() { this.load() }

  async load() {
    const res = await fetch(`${this.basePathValue}/projects/${this.projectIdValue}/project_comments`, { headers: { Accept: "application/json" } })
    if (!res.ok) {
      this.setStatus("댓글을 불러오지 못했습니다.")
      return
    }
    const comments = await res.json()
    this.renderComments(comments)
    this.setStatus("")
  }

  async submit(ev) {
    ev.preventDefault()
    const body = this.inputTarget.value.trim()
    if (!body) return
    const res = await fetch(`${this.basePathValue}/projects/${this.projectIdValue}/project_comments`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content, Accept: "application/json" },
      body: JSON.stringify({ body })
    })
    if (res.ok) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
      this.load()
    } else {
      this.setStatus("댓글을 저장하지 못했습니다.")
    }
  }

  renderComments(comments) {
    this.listTarget.replaceChildren()

    comments.forEach((comment) => {
      const item = document.createElement("li")
      item.className = "project-comments__item"

      const author = document.createElement("strong")
      author.className = "project-comments__author"
      author.textContent = comment.user?.email || "Unknown"

      const body = document.createElement("p")
      body.className = "project-comments__body"
      body.textContent = comment.body || ""

      item.append(author, body)
      this.listTarget.appendChild(item)
    })
  }

  setStatus(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
  }
}
